import fetch from '../../utils/fetch';
import { getClientToken } from '../../utils/helpers';
import { API_ROUTES } from '../../utils/constants';

export const registrationAPI = (data) => {
  let formData = {};
  const accessToken = getClientToken().access_token;

  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${accessToken}`,
  };

  formData.email = data.username;
  formData.password = data.password;
  formData = JSON.stringify(formData);
  return fetch({
    method: 'POST', route: API_ROUTES.REGISTRATION, requestHeaders: headers, data: formData, basic: false,
  });
};


export const socialLoginAPI = ({ route, token }) => {
  const formData = new FormData();
  // const accessToken = getClientToken().access_token;

  const headers = {
    'Content-Type': 'multipart/form-data',

  };
  formData.append('token', token);

  return fetch({
    method: 'POST', route, requestHeaders: headers, data: formData, basic: false,
  });
};




// WEBPACK FOOTER //
// ./src/reducers/registration/api.js